module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isVisible) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v(_vm._s(_vm.msg))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23faba06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-message.vue
// module id = 431
// module chunks = 0